var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"employer"},[_c('router-view',{key:_vm.$route.path}),_c('PricingServicesPopups')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }